'use client';

import { memo, useCallback } from 'react';
import { InView, PlainChildrenProps } from 'react-intersection-observer';

export type InfiniteScrollDetectorProps = Omit<
  PlainChildrenProps,
  'onChange' | 'as' | 'ref'
> & {
  hasNextPage: boolean;
  fetchNextPage: () => void;
  className?: string;
  isFetchingNextPage?: boolean;
};

const InfiniteScrollDetector = ({
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  ...inViewProps
}: InfiniteScrollDetectorProps) => {
  const handleChangeInView = useCallback(
    (inView: boolean) => {
      if (inView && hasNextPage && !isFetchingNextPage) fetchNextPage();
    },
    [fetchNextPage, hasNextPage, isFetchingNextPage],
  );

  return <InView onChange={handleChangeInView} {...inViewProps} />;
};

export default memo(InfiniteScrollDetector);
